// A deploy replaces every lazily loaded page's files (blue/green: the old
// frontend stops serving). A tab opened before the deploy still asks for the
// old ones, the import fails, vue-router aborts the navigation, and the
// click does nothing: no error on screen, the URL never changes. Mark hit
// exactly this on Billing > Edit invoice right after a deploy (2026-10-04).
//
// The fix is the one a person would make: load the page they asked for,
// fresh. Once per target, so a page that is really broken shows its error
// instead of reloading forever.

const STALE_CHUNK = [
  /Loading chunk [\w-]+ failed/i, // webpack JS chunk
  /Loading CSS chunk [\w-]+ failed/i, // mini-css-extract
  /Failed to fetch dynamically imported module/i, // native import()
  /Importing a module script failed/i, // Safari's wording
];

const KEY = 'lw:stale-chunk-reload';

export function isStaleChunkError(err) {
  if (!err) return false;
  if (err.name === 'ChunkLoadError') return true;
  const message = String((err && err.message) || err);
  return STALE_CHUNK.some(p => p.test(message));
}

function read(win) {
  try {
    return win.sessionStorage.getItem(KEY);
  } catch (e) {
    return null;
  }
}

function write(win, value) {
  try {
    if (value === null) win.sessionStorage.removeItem(KEY);
    else win.sessionStorage.setItem(KEY, value);
  } catch (e) {
    /* storage refused (private mode): the reload still happens once per click */
  }
}

/**
 * installStaleChunkReload(router, { win }) wires the reload. `win` is for
 * tests; it defaults to the real window.
 */
export function installStaleChunkReload(router, { win = window } = {}) {
  router.onError((err, to) => {
    if (!isStaleChunkError(err)) return;
    const target = (to && to.fullPath) || win.location.pathname;
    if (read(win) === target) return; // already reloaded for this page once
    write(win, target);
    win.location.assign(target);
  });
  // A navigation that completes means the files are current again.
  router.afterEach(() => write(win, null));
}
